import { UserPermissions } from '../../../components/User';
import { UserType } from '../../../types';

export function MemberUserPermissions() {
  return <UserPermissions type={UserType.Member} />;
}
